export default "﻿<div>\n    <div data-dojo-attach-point=\"tableContainer\">${translations.General__NoEntries}</div>\n\n</div>\n"